import { Box, Grid, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { MAX_ORDER_COMMENT_LENGTH } from "../../../../../../constants/inputValidationDefaults"
import { FormikSwitch, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useDateTime } from "../../../../../localization/useDateTime"

import { CreateUpdateWorkgroup, HistoryType } from "../workgroupsTypes"

const useStyles = makeStyles()((theme) => ({
    halfWidth: {
        width: "50%",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
}))

type CreateUpdateWorkgroupFormContentProps = Readonly<{
    history?: HistoryType
}>

export function CreateUpdateWorkgroupFormContent({ history }: CreateUpdateWorkgroupFormContentProps) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    return (
        <StandardForm>
            <StandardMainPanel>
                <Box className={classes.halfWidth}>
                    <LocalizedStrict
                        id="create-or-edit-company-workgroup-field-name"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikTextField name="name" label="Name" placeholder="Enter name" required fullWidth />
                    </LocalizedStrict>
                </Box>
                <Box className={classes.halfWidth}>
                    <LocalizedStrict
                        id="create-or-edit-company-workgroup-field-calendar-email"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikTextField
                            name="calendarEmailAddress"
                            label="Calendar"
                            placeholder="Enter calendar"
                            fullWidth
                        />
                    </LocalizedStrict>
                </Box>
                <LocalizedStrict
                    id="create-or-edit-company-workgroup-field-description"
                    attrs={{ label: true, placeholder: true }}
                >
                    <FormikTextField
                        name="description"
                        label="Description"
                        placeholder="Enter description"
                        multiline
                        minRows={3}
                        maxRows={5}
                        inputProps={{ maxLength: MAX_ORDER_COMMENT_LENGTH }}
                        fullWidth
                    />
                </LocalizedStrict>
            </StandardMainPanel>
            <LocalizedStrict id="create-or-edit-company-workgroup-settings" attrs={{ title: true }}>
                <StandardSidePanel title="Settings" variant="collapsible">
                    <LocalizedStrict id="create-or-edit-company-workgroup-field-active">
                        <FormikSwitch<CreateUpdateWorkgroup> name="isActive">Active</FormikSwitch>
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>
            {history && (
                <LocalizedStrict id="create-or-edit-company-workgroup-history" attrs={{ title: true }}>
                    <StandardSidePanel title="History" variant="collapsible">
                        <Grid container item>
                            <Grid item xs={12} sm={5} justifyContent="space-between">
                                <LocalizedStrict id="history-created">
                                    <Typography variant="body2">Created:</Typography>
                                </LocalizedStrict>
                            </Grid>
                            <Grid item xs={12} sm={7}>
                                <Typography variant="body2" textAlign="right">
                                    {dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(history.created.timestamp))}
                                </Typography>
                                <Typography variant="body2" textAlign="right">
                                    {history.created.author ?? "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container item>
                            <Grid item xs={12} sm={5}>
                                <LocalizedStrict id="history-edited">
                                    <Typography variant="body2">Edited:</Typography>
                                </LocalizedStrict>
                            </Grid>
                            <Grid item xs={12} sm={7}>
                                <Typography variant="body2" textAlign="right">
                                    {history.updated
                                        ? dateTimeFactory.formatDateTime(
                                              dateTimeFactory.fromApi(history.updated.timestamp),
                                          )
                                        : "-"}
                                </Typography>
                                <Typography variant="body2" textAlign="right">
                                    {history.updated?.author ?? "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </StandardSidePanel>
                </LocalizedStrict>
            )}
        </StandardForm>
    )
}

